import { OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { from } from 'rxjs';
import { ScriptInjectorService } from 'src/app/core/services/script-injector.service';
import { environment } from 'src/environments/environment';
import * as fromAuth from '../../../auth/reducers';
var DashboardFoldersV3Component = /** @class */ (function () {
    function DashboardFoldersV3Component(_store, _scriptInjector) {
        this._store = _store;
        this._scriptInjector = _scriptInjector;
    }
    DashboardFoldersV3Component.prototype.ngOnInit = function () {
        this.selectedLanguage$ = this._store.pipe(select(fromAuth.getLanguageCode));
        this.xSalveClinicToken$ = this._store.pipe(select(fromAuth.getClinicId));
        this.clinicMessagingLoaded$ = from(this._scriptInjector
            .loadScript('salve-clinic-messaging-dashboard', environment.messagingDashboardComponentUrl)
            .then(function () { return true; })
            .catch(function () { return false; }));
    };
    return DashboardFoldersV3Component;
}());
export { DashboardFoldersV3Component };
